var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#29EFA8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_822)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8218 16.4264C29.8218 19.4217 27.3924 21.8528 24.3954 21.8528C21.3984 21.8528 18.969 19.4217 18.969 16.4264C18.969 13.431 21.3984 11 24.3954 11C27.3924 11 29.8218 13.431 29.8218 16.4264Z",
    fill: "#29EFA8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3954 24.0234C18.1008 24.0234 13 28.6413 13 34.3336C13 35.8312 14.215 37.0468 15.7132 37.0468H33.0776C34.5758 37.0468 35.7908 35.8312 35.7908 34.3336C35.7908 28.6413 30.69 24.0234 24.3954 24.0234Z",
    fill: "#29EFA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.7908,
    height: 26.0466,
    fill: "white",
    transform: "translate(13 11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterUser);
export default __webpack_public_path__ + "static/media/footerUser.5f5d3d6ed72d51fbd04a9baed3cbe0e4.svg";
export { ForwardRef as ReactComponent };